const languages: {
  [_key: string]: {
    code: string
    name: string
    nativeName: string
    localeCode?: string
  }
} = {
  aa: {
    code: 'aa',
    name: 'Afar',
    nativeName: 'Afaraf',
    localeCode: 'aa-DJ',
  },
  ab: {
    code: 'ab',
    name: 'Abkhaz',
    nativeName: 'аҧсуа бызшәа, аҧсшәа',
    localeCode: 'ab-GE',
  },
  ae: {
    code: 'ae',
    name: 'Avestan',
    nativeName: 'avesta',
    localeCode: 'ae-IR',
  },
  af: {
    code: 'af',
    name: 'Afrikaans',
    nativeName: 'Afrikaans',
    localeCode: 'af-ZA',
  },
  ak: {
    code: 'ak',
    name: 'Akan',
    nativeName: 'Akan',
    localeCode: 'ak-GH',
  },
  am: {
    code: 'am',
    name: 'Amharic',
    nativeName: 'አማርኛ',
    localeCode: 'am-ET',
  },
  an: {
    code: 'an',
    name: 'Aragonese',
    nativeName: 'aragonés',
    localeCode: 'an-AD',
  },
  ar: {
    code: 'ar',
    name: 'Arabic',
    nativeName: 'العربية',
    localeCode: 'ar-SA',
  },
  as: {
    code: 'as',
    name: 'Assamese',
    nativeName: 'অসমীয়া',
    localeCode: 'as-IN',
  },
  av: {
    code: 'av',
    name: 'Avaric',
    nativeName: 'авар мацӀ, магӀарул мацӀ',
    localeCode: 'av-RU',
  },
  ay: {
    code: 'ay',
    name: 'Aymara',
    nativeName: 'aymar aru',
    localeCode: 'ay-PE',
  },
  az: {
    code: 'az',
    name: 'Azerbaijani',
    nativeName: 'azərbaycan dili',
    localeCode: 'az-AZ',
  },
  ba: {
    code: 'ba',
    name: 'Bashkir',
    nativeName: 'башҡорт теле',
    localeCode: 'ba-RU',
  },
  be: {
    code: 'be',
    name: 'Belarusian',
    nativeName: 'беларуская мова',
    localeCode: 'be-BY',
  },
  bg: {
    code: 'bg',
    name: 'Bulgarian',
    nativeName: 'български език',
    localeCode: 'bg-BG',
  },
  bh: {
    code: 'bh',
    name: 'Bihari',
    nativeName: 'भोजपुरी',
    localeCode: 'bh-IN',
  },
  bi: {
    code: 'bi',
    name: 'Bislama',
    nativeName: 'Bislama',
    localeCode: 'bi-VU',
  },
  bm: {
    code: 'bm',
    name: 'Bambara',
    nativeName: 'bamanankan',
    localeCode: 'bm-ML',
  },
  bn: {
    code: 'bn',
    name: 'Bengali',
    nativeName: 'বাংলা',
    localeCode: 'bn-BD',
  },
  bo: {
    code: 'bo',
    name: 'Tibetan',
    nativeName: 'བོད་ཡིག',
    localeCode: 'bo-CN',
  },
  br: {
    code: 'br',
    name: 'Breton',
    nativeName: 'brezhoneg',
    localeCode: 'br-FR',
  },
  bs: {
    code: 'bs',
    name: 'Bosnian',
    nativeName: 'bosanski jezik',
    localeCode: 'bs-BA',
  },
  ca: {
    code: 'ca',
    name: 'Catalan',
    nativeName: 'català',
    localeCode: 'ca-ES',
  },
  cs: {
    code: 'cs',
    name: 'Czech',
    nativeName: 'česky, čeština',
    localeCode: 'cs-CZ',
  },
  da: {
    code: 'da',
    name: 'Danish',
    nativeName: 'dansk',
  },
  dv: {
    code: 'dv',
    name: 'Dhivehi',
    nativeName: 'ދިވެހި',
  },
  nl: {
    code: 'nl',
    name: 'Dutch',
    nativeName: 'Nederlands, Vlaams',
  },
  en: {
    code: 'en',
    name: 'English',
    nativeName: 'English',
  },
  eo: {
    code: 'eo',
    name: 'Esperanto',
    nativeName: 'Esperanto',
  },
  et: {
    code: 'et',
    name: 'Estonian',
    nativeName: 'eesti, eesti keel',
  },
  ee: {
    code: 'ee',
    name: 'Ewe',
    nativeName: 'Eʋegbe',
  },
  fo: {
    code: 'fo',
    name: 'Faroese',
    nativeName: 'føroyskt',
  },
  fj: {
    code: 'fj',
    name: 'Fijian',
    nativeName: 'vosa Vakaviti',
  },
  fi: {
    code: 'fi',
    name: 'Finnish',
    nativeName: 'suomi, suomen kieli',
  },
  fr: {
    code: 'fr',
    name: 'French',
    nativeName: 'français, langue française',
  },
  ff: {
    code: 'ff',
    name: 'Fula',
    nativeName: 'Fulfulde, Pulaar, Pular',
  },
  gl: {
    code: 'gl',
    name: 'Galician',
    nativeName: 'Galego',
  },
  ka: {
    code: 'ka',
    name: 'Georgian',
    nativeName: 'ქართული',
  },
  de: {
    code: 'de',
    name: 'German',
    nativeName: 'Deutsch',
  },
  el: {
    code: 'el',
    name: 'Greek',
    nativeName: 'Ελληνικά',
  },
  gn: {
    code: 'gn',
    name: 'Guaraní',
    nativeName: 'Avañeẽ',
  },
  gu: {
    code: 'gu',
    name: 'Gujarati',
    nativeName: 'ગુજરાતી',
  },
  ht: {
    code: 'ht',
    name: 'Haitian Creole',
    nativeName: 'Kreyòl ayisyen',
  },
  ha: {
    code: 'ha',
    name: 'Hausa',
    nativeName: 'Hausa, هَوُسَ',
  },
  he: {
    code: 'he',
    name: 'Hebrew',
    nativeName: 'עברית',
  },
  hz: {
    code: 'hz',
    name: 'Herero',
    nativeName: 'Otjiherero',
  },
  hi: {
    code: 'hi',
    name: 'Hindi',
    nativeName: 'हिन्दी, हिंदी',
  },
  ho: {
    code: 'ho',
    name: 'Hiri Motu',
    nativeName: 'Hiri Motu',
  },
  hu: {
    code: 'hu',
    name: 'Hungarian',
    nativeName: 'Magyar',
  },
  ia: {
    code: 'ia',
    name: 'Interlingua',
    nativeName: 'Interlingua',
  },
  id: {
    code: 'id',
    name: 'Indonesian',
    nativeName: 'Bahasa Indonesia',
  },
  ie: {
    code: 'ie',
    name: 'Interlingue',
    nativeName: 'Originally called Occidental; then Interlingue after WWII',
  },
  ga: {
    code: 'ga',
    name: 'Irish',
    nativeName: 'Gaeilge',
  },
  ig: {
    code: 'ig',
    name: 'Igbo',
    nativeName: 'Asụsụ Igbo',
  },
  ik: {
    code: 'ik',
    name: 'Inupiaq',
    nativeName: 'Iñupiaq, Iñupiatun',
  },
  io: {
    code: 'io',
    name: 'Ido',
    nativeName: 'Ido',
  },
  is: {
    code: 'is',
    name: 'Icelandic',
    nativeName: 'Íslenska',
  },
  it: {
    code: 'it',
    name: 'Italian',
    nativeName: 'Italiano',
  },
  iu: {
    code: 'iu',
    name: 'Inuktitut',
    nativeName: 'ᐃᓄᒃᑎᑐᑦ',
  },
  ja: {
    code: 'ja',
    name: 'Japanese',
    nativeName: '日本語 (にほんご／にっぽんご)',
  },
  jv: {
    code: 'jv',
    name: 'Javanese',
    nativeName: 'basa Jawa',
  },
  kl: {
    code: 'kl',
    name: 'Kalaallisut',
    nativeName: 'kalaallisut, kalaallit oqaasii',
  },
  kn: {
    code: 'kn',
    name: 'Kannada',
    nativeName: 'ಕನ್ನಡ',
  },
  kr: {
    code: 'kr',
    name: 'Kanuri',
    nativeName: 'Kanuri',
  },
  ks: {
    code: 'ks',
    name: 'Kashmiri',
    nativeName: 'कश्मीरी, كشميري‎',
  },
  kk: {
    code: 'kk',
    name: 'Kazakh',
    nativeName: 'Қазақ тілі',
  },
  km: {
    code: 'km',
    name: 'Khmer',
    nativeName: 'ភាសាខ្មែរ',
  },
  ki: {
    code: 'ki',
    name: 'Kikuyu',
    nativeName: 'Gĩkũyũ',
  },
  rw: {
    code: 'rw',
    name: 'Kinyarwanda',
    nativeName: 'Ikinyarwanda',
  },
  ky: {
    code: 'ky',
    name: 'Kirghiz',
    nativeName: 'кыргыз тили',
  },
  kv: {
    code: 'kv',
    name: 'Komi',
    nativeName: 'коми кыв',
  },
  kg: {
    code: 'kg',
    name: 'Kongo',
    nativeName: 'KiKongo',
  },
  ko: {
    code: 'ko',
    name: 'Korean',
    nativeName: '한국어 (韓國語), 조선말 (朝鮮語)',
  },
  ku: {
    code: 'ku',
    name: 'Kurdish',
    nativeName: 'Kurdî, كوردی‎',
  },
  kj: {
    code: 'kj',
    name: 'Kwanyama',
    nativeName: 'Kuanyama',
  },
  la: {
    code: 'la',
    name: 'Latin',
    nativeName: 'latine, lingua latina',
  },
  lb: {
    code: 'lb',
    name: 'Luxembourgish',
    nativeName: 'Lëtzebuergesch',
  },
  lg: {
    code: 'lg',
    name: 'Luganda',
    nativeName: 'Luganda',
  },
  li: {
    code: 'li',
    name: 'Limburgish',
    nativeName: 'Limburgs',
  },
  ln: {
    code: 'ln',
    name: 'Lingala',
    nativeName: 'Lingála',
  },
  lo: {
    code: 'lo',
    name: 'Lao',
    nativeName: 'ພາສາລາວ',
  },
  lt: {
    code: 'lt',
    name: 'Lithuanian',
    nativeName: 'lietuvių kalba',
  },
  lu: {
    code: 'lu',
    name: 'Luba-Katanga',
    nativeName: '',
  },
  lv: {
    code: 'lv',
    name: 'Latvian',
    nativeName: 'latviešu valoda',
  },
  gv: {
    code: 'gv',
    name: 'Manx',
    nativeName: 'Gaelg',
  },
  mk: {
    code: 'mk',
    name: 'Macedonian',
    nativeName: 'македонски јазик',
  },
  mg: {
    code: 'mg',
    name: 'Malagasy',
    nativeName: 'Malagasy fiteny',
  },
  ms: {
    code: 'ms',
    name: 'Malay',
    nativeName: 'bahasa Melayu, بهاس ملايو‎',
  },
  ml: {
    code: 'ml',
    name: 'Malayalam',
    nativeName: 'മലയാളം',
  },
  mt: {
    code: 'mt',
    name: 'Maltese',
    nativeName: 'Malti',
  },
  mi: {
    code: 'mi',
    name: 'Māori',
    nativeName: 'te reo Māori',
  },
  mr: {
    code: 'mr',
    name: 'Marathi (Marāṭhī)',
    nativeName: 'मराठी',
  },
  mh: {
    code: 'mh',
    name: 'Marshallese',
    nativeName: 'Kajin M̧ajeļ',
  },
  mn: {
    code: 'mn',
    name: 'Mongolian',
    nativeName: 'монгол',
  },
  na: {
    code: 'na',
    name: 'Nauru',
    nativeName: 'Ekakairũ Naoero',
  },
  nv: {
    code: 'nv',
    name: 'Navajo',
    nativeName: 'Diné bizaad, Dinékʼehǰí',
  },
  nb: {
    code: 'nb',
    name: 'Norwegian Bokmål',
    nativeName: 'Norsk bokmål',
  },
  nd: {
    code: 'nd',
    name: 'North Ndebele',
    nativeName: 'isiNdebele',
  },
  ne: {
    code: 'ne',
    name: 'Nepali',
    nativeName: 'नेपाली',
  },
  ng: {
    code: 'ng',
    name: 'Ndonga',
    nativeName: 'Owambo',
  },
  nn: {
    code: 'nn',
    name: 'Norwegian Nynorsk',
    nativeName: 'Norsk nynorsk',
  },
  no: {
    code: 'no',
    name: 'Norwegian',
    nativeName: 'Norsk',
  },
  ii: {
    code: 'ii',
    name: 'Nuosu',
    nativeName: 'ꆈꌠ꒿ Nuosuhxop',
  },
  nr: {
    code: 'nr',
    name: 'South Ndebele',
    nativeName: 'isiNdebele',
  },
  oc: {
    code: 'oc',
    name: 'Occitan',
    nativeName: 'Occitan',
  },
  oj: {
    code: 'oj',
    name: 'Ojibwe',
    nativeName: 'ᐊᓂᔑᓈᐯᒧᐎᓐ',
  },
  cu: {
    code: 'cu',
    name: 'Old Church Slavonic',
    nativeName: 'ѩзыкъ словѣньскъ',
    localeCode: 'cu-RU',
  },
  cv: {
    code: 'cv',
    name: 'Chuvash',
    nativeName: 'чӑваш чӗлхи',
    localeCode: 'cv-RU',
  },
  cy: {
    code: 'cy',
    name: 'Welsh',
    nativeName: 'Cymraeg',
    localeCode: 'cy-GB',
  },

  dz: {
    code: 'dz',
    name: 'Dzongkha',
    nativeName: 'རྫོང་ཁ',
    localeCode: 'dz-BT',
  },

  es: {
    code: 'es',
    name: 'Spanish',
    nativeName: 'español, castellano',
    localeCode: 'es-ES',
  },

  eu: {
    code: 'eu',
    name: 'Basque',
    nativeName: 'euskara, euskera',
    localeCode: 'eu-ES',
  },
  fa: {
    code: 'fa',
    name: 'Persian',
    nativeName: 'فارسی',
    localeCode: 'fa-IR',
  },
  fy: {
    code: 'fy',
    name: 'Western Frisian',
    nativeName: 'Frysk',
    localeCode: 'fy-NL',
  },
  hr: {
    code: 'hr',
    name: 'Croatian',
    nativeName: 'hrvatski jezik',
    localeCode: 'hr-HR',
  },

  hy: {
    code: 'hy',
    name: 'Armenian',
    nativeName: 'Հայերեն',
    localeCode: 'hy-AM',
  },

  kw: {
    code: 'kw',
    name: 'Cornish',
    nativeName: 'Kernewek',
    localeCode: 'kw-GB',
  },

  my: {
    code: 'my',
    name: 'Burmese',
    nativeName: 'ဗမာစာ',
    localeCode: 'my-MM',
  },

  ny: {
    code: 'ny',
    name: 'Chichewa',
    nativeName: 'chiCheŵa, chinyanja',
    localeCode: 'ny-MW',
  },

  om: {
    code: 'om',
    name: 'Oromo',
    nativeName: 'Afaan Oromoo',
    localeCode: 'om-ET',
  },
  or: {
    code: 'or',
    name: 'Oriya',
    nativeName: 'ଓଡ଼ିଆ',
    localeCode: 'or-IN',
  },
  os: {
    code: 'os',
    name: 'Ossetian',
    nativeName: 'ирон æвзаг',
    localeCode: 'os-RU',
  },
  pa: {
    code: 'pa',
    name: 'Punjabi',
    nativeName: 'ਪੰਜਾਬੀ, پنجابی‎',
    localeCode: 'pa-IN',
  },
  pi: {
    code: 'pi',
    name: 'Pāli',
    nativeName: 'पाऴि',
    localeCode: 'pi-001',
  },
  pl: {
    code: 'pl',
    name: 'Polish',
    nativeName: 'język polski, polszczyzna',
    localeCode: 'pl-PL',
  },
  ps: {
    code: 'ps',
    name: 'Pashto',
    nativeName: 'پښتو',
    localeCode: 'ps-AF',
  },
  pt: {
    code: 'pt',
    name: 'Portuguese',
    nativeName: 'Português',
    localeCode: 'pt-PT',
  },
  qu: {
    code: 'qu',
    name: 'Quechua',
    nativeName: 'Runa Simi, Kichwa',
    localeCode: 'qu-EC',
  },
  rm: {
    code: 'rm',
    name: 'Romansh',
    nativeName: 'rumantsch grischun',
    localeCode: 'rm-CH',
  },
  rn: {
    code: 'rn',
    name: 'Rundi',
    nativeName: 'Ikirundi',
    localeCode: 'rn-BI',
  },
  ro: {
    code: 'ro',
    name: 'Romanian',
    nativeName: 'Română',
    localeCode: 'ro-RO',
  },
  ru: {
    code: 'ru',
    name: 'Russian',
    nativeName: 'русский',
    localeCode: 'ru-RU',
  },

  sa: {
    code: 'sa',
    name: 'Sanskrit (Saṁskṛta)',
    nativeName: 'संस्कृतम्',
    localeCode: 'sa-IN',
  },
  sc: {
    code: 'sc',
    name: 'Sardinian',
    nativeName: 'sardu',
    localeCode: 'sc-IT',
  },
  sd: {
    code: 'sd',
    name: 'Sindhi',
    nativeName: 'सिन्धी, سنڌي، سندھی‎',
    localeCode: 'sd-IN',
  },
  se: {
    code: 'se',
    name: 'Northern Sami',
    nativeName: 'Davvisámegiella',
    localeCode: 'se-NO',
  },
  sm: {
    code: 'sm',
    name: 'Samoan',
    nativeName: "gagana fa'a Samoa",
    localeCode: 'sm-WS',
  },
  sg: {
    code: 'sg',
    name: 'Sango',
    nativeName: 'yângâ tî sängö',
    localeCode: 'sg-CF',
  },
  sr: {
    code: 'sr',
    name: 'Serbian',
    nativeName: 'српски језик',
    localeCode: 'sr-RS',
  },
  gd: {
    code: 'gd',
    name: 'Scottish Gaelic',
    nativeName: 'Gàidhlig',
    localeCode: 'gd-GB',
  },
  sn: {
    code: 'sn',
    name: 'Shona',
    nativeName: 'chiShona',
    localeCode: 'sn-ZW',
  },
  si: {
    code: 'si',
    name: 'Sinhala',
    nativeName: 'සිංහල',
    localeCode: 'si-LK',
  },
  sk: {
    code: 'sk',
    name: 'Slovak',
    nativeName: 'slovenčina, slovenský jazyk',
    localeCode: 'sk-SK',
  },
  sl: {
    code: 'sl',
    name: 'Slovenian',
    nativeName: 'slovenski jezik, slovenščina',
    localeCode: 'sl-SI',
  },
  so: {
    code: 'so',
    name: 'Somali',
    nativeName: 'Soomaaliga, af Soomaali',
    localeCode: 'so-SO',
  },
  sq: {
    code: 'sq',
    name: 'Albanian',
    nativeName: 'Shqip',
    localeCode: 'sq-AL',
  },
  ss: {
    code: 'ss',
    name: 'Swati',
    nativeName: 'SiSwati',
    localeCode: 'ss-SZ',
  },
  st: {
    code: 'st',
    name: 'Southern Sotho',
    nativeName: 'Sesotho',
    localeCode: 'st-LS',
  },
  su: {
    code: 'su',
    name: 'Sundanese',
    nativeName: 'Basa Sunda',
    localeCode: 'su-ID',
  },
  sv: {
    code: 'sv',
    name: 'Swedish',
    nativeName: 'Svenska',
    localeCode: 'sv-SE',
  },
  sw: {
    code: 'sw',
    name: 'Swahili',
    nativeName: 'Kiswahili',
    localeCode: 'sw-KE',
  },
  ta: {
    code: 'ta',
    name: 'Tamil',
    nativeName: 'தமிழ்',
    localeCode: 'ta-IN',
  },
  te: {
    code: 'te',
    name: 'Telugu',
    nativeName: 'తెలుగు',
    localeCode: 'te-IN',
  },
  tg: {
    code: 'tg',
    name: 'Tajik',
    nativeName: 'тоҷикӣ, toçikī, تاجیکی‎',
    localeCode: 'tg-TJ',
  },
  th: {
    code: 'th',
    name: 'Thai',
    nativeName: 'ไทย',
    localeCode: 'th-TH',
  },
  ti: {
    code: 'ti',
    name: 'Tigrinya',
    nativeName: 'ትግርኛ',
    localeCode: 'ti-ER',
  },
  tk: {
    code: 'tk',
    name: 'Turkmen',
    nativeName: 'Türkmen, Түркмен',
    localeCode: 'tk-TM',
  },
  tl: {
    code: 'tl',
    name: 'Tagalog',
    nativeName: 'Wikang Tagalog',
    localeCode: 'tl-PH',
  },
  tn: {
    code: 'tn',
    name: 'Tswana',
    nativeName: 'Setswana',
    localeCode: 'tn-BW',
  },
  to: {
    code: 'to',
    name: 'Tonga (Tonga Islands)',
    nativeName: 'faka Tonga',
    localeCode: 'to-TO',
  },
  tr: {
    code: 'tr',
    name: 'Turkish',
    nativeName: 'Türkçe',
    localeCode: 'tr-TR',
  },
  ts: {
    code: 'ts',
    name: 'Tsonga',
    nativeName: 'Xitsonga',
    localeCode: 'ts-ZA',
  },
  tt: {
    code: 'tt',
    name: 'Tatar',
    nativeName: 'татар теле, tatar tele',
    localeCode: 'tt-RU',
  },
  tw: {
    code: 'tw',
    name: 'Twi',
    nativeName: 'Twi',
    localeCode: 'tw-GH',
  },
  ty: {
    code: 'ty',
    name: 'Tahitian',
    nativeName: 'Reo Tahiti',
    localeCode: 'ty-PF',
  },
  ug: {
    code: 'ug',
    name: 'Uighur',
    nativeName: 'ئۇيغۇرچە‎, Uyghurche',
    localeCode: 'ug-CN',
  },
  uk: {
    code: 'uk',
    name: 'Ukrainian',
    nativeName: 'українська мова',
    localeCode: 'uk-UA',
  },
  ur: {
    code: 'ur',
    name: 'Urdu',
    nativeName: 'اردو',
    localeCode: 'ur-PK',
  },
  uz: {
    code: 'uz',
    name: 'Uzbek',
    nativeName: 'zbek, Ўзбек, أۇزبېك‎',
    localeCode: 'uz-UZ',
  },
  ve: {
    code: 've',
    name: 'Venda',
    nativeName: 'Tshivenḓa',
    localeCode: 've-ZA',
  },
  vi: {
    code: 'vi',
    name: 'Vietnamese',
    nativeName: 'Tiếng Việt',
    localeCode: 'vi-VN',
  },
  vo: {
    code: 'vo',
    name: 'Volapük',
    nativeName: 'Volapük',
    localeCode: 'vo-001',
  },
  wa: {
    code: 'wa',
    name: 'Walloon',
    nativeName: 'Walon',
    localeCode: 'wa-BE',
  },
  wo: {
    code: 'wo',
    name: 'Wolof',
    nativeName: 'Wollof',
    localeCode: 'wo-SN',
  },
  xh: {
    code: 'xh',
    name: 'Xhosa',
    nativeName: 'isiXhosa',
    localeCode: 'xh-ZA',
  },
  yi: {
    code: 'yi',
    name: 'Yiddish',
    nativeName: 'ייִדיש',
    localeCode: 'yi-001',
  },
  yo: {
    code: 'yo',
    name: 'Yoruba',
    nativeName: 'Yorùbá',
    localeCode: 'yo-NG',
  },
  za: {
    code: 'za',
    name: 'Zhuang',
    nativeName: 'Saɯ cueŋƅ, Saw cuengh',
    localeCode: 'za-CN',
  },
  zh: {
    code: 'zh',
    name: 'Chinese',
    nativeName: '中文 (Zhōngwén), 汉语, 漢語',
    localeCode: 'zh-CN',
  },
  zu: {
    code: 'zu',
    name: 'Zulu',
    nativeName: 'isiZulu',
    localeCode: 'zu-ZA',
  },
}

export default languages
